export default {
  CLUB_COMM: "clubComm",
  MAIN_TOURNAMENT: "mainTournament",
  CHANGE_YEAR: "changeYear"
};
